import { render, staticRenderFns } from "./resume-educations.vue?vue&type=template&id=7ba3ca45&"
import script from "./resume-educations.vue?vue&type=script&lang=js&"
export * from "./resume-educations.vue?vue&type=script&lang=js&"
import style0 from "./resume-educations.vue?vue&type=style&index=0&id=7ba3ca45&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports